import React, { useEffect } from "react";
import { Grid2 } from "@mui/material";
// styles
import styles from "./WelcomePlanCard.module.scss";
import CustomButton from "../CustomButton/CustomButton";
import { ReactComponent as Launchpad } from "../../Features/Admin/AdminAssets/svg/LaunchPad.svg";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { Actions } from "../../redux/constants/actionTypes";
import { getStore } from "../../Utils/storeUtils";

export default function WelcomePlanCard(props) {
  const navigate = useNavigate();
  const userDetails = useSelector((state) => state.users?.userDetails);
  const selectedOrg = useSelector(
    (state) => state.organizationsInfo?.selectedOrg
  );
  const allPlans = useSelector(
    (state) => state.plansInfo.allPlans?.plans?.licenses
  );
  const orgName = selectedOrg?.orgId ? selectedOrg?.orgId : -1;

  const urlPath = window.location.pathname;
  const segments = urlPath.split("/");
  const Ind = segments[2];

  useEffect(() => {
    getStore().dispatch({ type: Actions.API_ALL_PLANS });
  }, []);

  const launchPadSingleSitePlan = allPlans?.find(
    (plan) => plan.licenseType === "LaunchPad" && plan.isSingleSitePlan === true
  );
  const monthlyPricing = launchPadSingleSitePlan?.pricing?.find(
    (price) => price.billingType === "Monthly"
  );
  const yearlyPricing = launchPadSingleSitePlan?.pricing?.find(
    (price) => price.billingType === "Yearly"
  );

  const getPlanDetails = (cycle) => {
    const pricing = cycle === "monthly" ? monthlyPricing : yearlyPricing;
    const country = Ind === "-1" ? userDetails?.country : selectedOrg?.country;

    let price, currencySymbol;
    if (country === "USA") {
      price = pricing?.originalprice;
      currencySymbol = "$";
    } else {
      price = pricing?.orginalPrice_INR;
      currencySymbol = "₹";
    }

    const adjustedPrice = cycle === "yearly" ? price / 12 : price;

    return {
      price: adjustedPrice,
      currencySymbol,
    };
  };
  const monthlyDetails = getPlanDetails("monthly");
  const yearlyDetails = getPlanDetails("yearly");

  return (
    <>
      <Grid2 className={styles.WelcomePlanCardContainer}>
        <Launchpad className={styles.planImage} />
        <Grid2>
          <Grid2 className={styles.soloPlan}>Start with Solo-Site plans</Grid2>
          <Grid2 className={styles.PlanName}>
            {launchPadSingleSitePlan?.licenseType}
          </Grid2>
          <Grid2>
            <span className={styles.month}>
              {monthlyDetails.currencySymbol}{" "}
              <span className={styles.monthdecoration}>
                {monthlyDetails.price}{" "}
              </span>
              /mon
            </span>
          </Grid2>
        </Grid2>
        <Grid2 className={styles.FlexBoxPrice}>
          <Grid2 className={styles.priceFlexBox}>
            <Grid2 className={styles.price}>
              {yearlyDetails.currencySymbol}
              {yearlyDetails.price.toFixed(2)}
            </Grid2>
            <Grid2 className={styles.priceMonth}>/mon</Grid2>
          </Grid2>
          <Grid2 className={styles.buynowFlexBox}>
            {/* <Grid2
              className={styles.ChoosePlan}
              onClick={() => {
                navigate(`/account/${orgName}/modify-plan`);
              }}
            >
              Explore other Plans
            </Grid2> */}
            <CustomButton
              className={styles.BuyNow}
              onClick={() => {
                navigate(`/account/${orgName}/modify-plan`);
              }}
            >
              Get Started
            </CustomButton>
          </Grid2>
        </Grid2>
      </Grid2>
    </>
  );
}
